import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './RegisterInvitedApplicant.css';
import PersonalData from '../personalData/PersonalData.container';
import { PERSONAL_FORM_MODE } from './../personalData/PersonalData';
import ConfirmPassword from '../confirmPassword/ConfirmPasswordActivation.container';
import FormWrapper from '../../commonComponents/formWrapper/FormWrapper.container';
import { Redirect } from "react-router-dom";
import { Button, Form, Label, Input } from 'reactstrap';
import _ from 'lodash';
import { Utils } from '../../../utils/utils';
import LicenseAgreementModal from '../../commonComponents/licenseAgreement/LicenseAgreementModal.container';
import { sharedLabelsPath } from "../../../reducers/common/localization";

const requiredSelectFields = ['countryCode'];

class RegisterInvitedApplicant extends Component {
    constructor(props) {
        super(props);
        this.state = {
            firstName: '',
            lastName: '',
            email: '',
            phoneNumber: '',
            countryCode: '',
            password: '',
            passwordConfirm: '',
            isAgreeWithLicense: false,
            requiredFieldError: null
        };

        if (this.props.data){
            this.state.firstName = this.props.data.firstName || "";
            this.state.lastName = this.props.data.lastName || "";
            this.state.email = this.props.data.email || "";
            this.state.countryCode = this.props.data.countryCode || "";
        }
    }

    componentWillMount() {
        if (this.props.data) {
            this.props.onCheckEmailAvailability(this.props.data.email);
        }
    }

    render() {
        if (this.props.success) {
            return <Redirect to="/login" />;
        }
        if (this.props.loading) {
            return <h6 className="text-center">{_.get(this.props.translation, sharedLabelsPath.fetching_message)}</h6>;
        }
        if (_.isNil(this.props.data)) {
            return <h6 className="incorrect-activation-invited-applicant-container">{_.get(this.props.translation, 'activation.incorrect_activation_link_alert')}</h6>;
        }
        if (!this.props.isEmailAvailable) {
            return this.getLinkIrrelevantMessage();
        }
        return (
            <div className="activation-invited-applicant-container">
                <FormWrapper
                    successMessage={_.get(this.props.translation, 'activation.activation_success_alert')}
                >
                    <h4 className='page-label'>{_.get(this.props.translation, 'activation.label')}</h4>
                    <Form onSubmit={this.onActivate} key="activate-form">
                        <h6>{_.get(this.props.translation, 'activation.activate_personal_data_label')}</h6>
                        <PersonalData
                            handleChange={this.handleChange}
                            handleChangeByValue={this.handleChangeByValue}
                            firstName={this.state.firstName}
                            lastName={this.state.lastName}
                            email={this.state.email}
                            phoneNumber={this.state.phoneNumber}
                            countryCode={this.state.countryCode}
                            requiredFields={['firstName', 'lastName', 'email', 'continentCode', 'countryCode']}
                            requiredFieldError={this.state.requiredFieldError}
                            mode={PERSONAL_FORM_MODE}
                        />
                        <h6>{_.get(this.props.translation, 'activation.activate_password_label')}</h6>
                        <ConfirmPassword
                            handleChange={this.handleChange}
                            password={this.state.password}
                            passwordConfirm={this.state.passwordConfirm}
                        />
                        <div className="submit-activation-invited-applicant-container">
                            <div className="license-agreement-container">
                                <Label className='checkbox-label'>
                                    <Input
                                        type="checkbox"
                                        checked={this.state.isAgreeWithLicense}
                                        onChange={this.handleChangeAgreement}
                                    />
                                    {_.get(this.props.translation, "license_agreement.agree_label")}
                                    <a href="" className="license-agreement-link" onClick={this.handleClickLicenseAgreement}>
                                        {_.get(this.props.translation, "license_agreement.agree_link")}
                                    </a>
                                </Label>
                            </div>
                            <Button type="submit" className="olive-green-btn" disabled={!this.state.isAgreeWithLicense}>{_.get(this.props.translation, 'activation.activate_button')}</Button>
                        </div>
                    </Form>
                </FormWrapper>
                <LicenseAgreementModal onAgree={this.setAgreementTrue} />
            </div>
        );
    }

    handleClickLicenseAgreement = (e) => {
        e.preventDefault();

        this.props.onShowLicenseAgreement();
    };

    getLinkIrrelevantMessage = () => {
        return (
            <div className="irrelevant-invited-applicant-activation-link">
               <h5>{_.get(this.props.translation, 'activation.activation_link_irrelevant_message')}</h5>
                <div>
                    <span>{_.get(this.props.translation, 'activation.activation_link_irrelevant_forgot_password_message_start')}</span>
                    <span><a href="/login/restore">{_.get(this.props.translation, 'activation.activation_link_irrelevant_forgot_password_message_link')}</a></span>
                    <span>{_.get(this.props.translation, 'activation.activation_link_irrelevant_forgot_password_message_end')}</span>
                </div>
                <div>
                    <span>{_.get(this.props.translation, 'activation.activation_link_irrelevant_log_in_message_start')}</span>
                    <span><a href="/login">{_.get(this.props.translation, 'activation.activation_link_irrelevant_log_in_message_link')}</a></span>
                    <span>{_.get(this.props.translation, 'activation.activation_link_irrelevant_log_in_message_end')}</span>
                </div>
            </div>
        )
    };

    handleChange = (fieldKey) => (e) => {
        this.setState({ [fieldKey]: e.target.value });
    };

    setAgreementTrue = () => {
        this.setState({ isAgreeWithLicense: true });
    };

    handleChangeByValue = (fieldKey) => (value) => {
        this.setState({ [fieldKey]: value });
    };

    handleChangeAgreement = () => {
        this.setState({ isAgreeWithLicense: !this.state.isAgreeWithLicense });
    };

    onActivate = (e) => {
        e.preventDefault();
        if (this.state.password !== '' && this.state.password === this.state.passwordConfirm && Utils.isValidPassword(this.state.password) && !this.checkRequiredSelectFields()) {

            let data = {
                password: this.state.password,
                token: this.props.data.token,
                email: this.state.email,
                identityAlias: {
                    firstName: this.state.firstName,
                    lastName: this.state.lastName,
                    phoneNumber: (!_.isNil(this.state.phoneNumber) && this.state.phoneNumber !== "") ? this.state.phoneNumber : null,
                    countryCode: this.state.countryCode
                }
            };

            this.props.onActivate(data);
        }
    };

    checkRequiredSelectFields = () => {
        let error = null;
        _.map(requiredSelectFields, field => {
            if (!this.state[field] && !error) {
                error = field;
            }
        });
        this.setState({requiredFieldError: error});
        return error;
    }
}

RegisterInvitedApplicant.propTypes = {
    location: PropTypes.object.isRequired,
    isEmailAvailable: PropTypes.bool,
    loading: PropTypes.bool,
    success: PropTypes.bool,
    data: PropTypes.object,
    translation: PropTypes.object.isRequired,
    onCheckEmailAvailability: PropTypes.func.isRequired,
    onActivate: PropTypes.func.isRequired,
    onShowLicenseAgreement: PropTypes.func.isRequired,
};

export default RegisterInvitedApplicant;



// WEBPACK FOOTER //
// ./src/components/accountManagement/registerInvitedApplicant/RegisterInvitedApplicant.js